import { ANALYTICS_EVENTS } from '../events'
import createAnalyticsStatic, { EventProps } from './createAnalyticsEvent'

export interface BlogClickedProps extends EventProps {
    slug?: string
}

/**
 * @event blog_clicked
 * @description Emitted when a blog card or blog link is clicked.
 */
export const BlogClickedAnalytics = createAnalyticsStatic<BlogClickedProps>(ANALYTICS_EVENTS.BLOGS.BLOG_CLICKED)

export default BlogClickedAnalytics
